<template>
  <div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :busy="loading"
      ref="modal"
      title="Your payment is being process"
    >
      <div class="text-center">
        <b-spinner variant="primary"></b-spinner>
        <p>Amount Payable: {{ purchase.amount }}</p>
        <p>You should receive a prompt on your phone to enter your PIN.</p>
        <p>Or dial *170#, go to your wallet, then approval</p>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="info" @click="doSubmit"> I've Paid </b-button>
      </template>
    </b-modal>
    <payment-success-modal ref="paymentSuccessModal"></payment-success-modal>
    <payment-failure-modal ref="paymentFailureModal"></payment-failure-modal>

  </div>
</template>

<script>
import PaymentSuccessModal from "@/components/PaymentSuccessModal.vue";
import PaymentFailureModal from "@/components/PaymentFailureModal.vue";

import ApiService from "@/plugins/ApiService";
import { mapState } from "vuex";

export default {
  name: "PaymentProcessModal",

  components: {
    PaymentSuccessModal,
    PaymentFailureModal
  },

  data() {
    return {
      intervalId: null,
      transaction_id: null,
      channel: null,
      provider: null,
    };
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      onLine: (state) => state.auth.onLine,
    }),
  },



  methods: {
    create(id, provider, channel) {
      this.$refs.modal.show();
      this.transaction_id = id;
      this.provider = provider;
      this.channel = channel;
      this.pollTransactionStatus();
    },

    pollTransactionStatus() {
      // Poll for transaction status
      this.intervalId = setInterval(() => {


        ApiService.post('settings/status', {
          channel: this.channel,
          provider: this.provider,
          id: this.transaction_id
        }).then((response) => {
            const status = response.data.status;

            console.log("STATUS", status);
            if (status === "success") {
              clearInterval(this.intervalId); // Stop polling
              this.intervalId = null;
              this.closeModal(); // Close the modal
              this.$refs.paymentSuccessModal.openModal();
            } else if (status === "failure" || status === "timeout") {
              clearInterval(this.intervalId); // Stop polling
              this.closeModal(); // Close the modal
              this.$refs.paymentFailureModal.openModal('Your payment was not successful. Please try again later.');

            }
          })
          .catch((error) => {
            console.log("poll err", error);
            // Handle error while checking transaction status
            this.progressMessage = `Error checking transaction status: ${error.message}`;
            clearInterval(intervalId); // Stop polling
            this.closeModal(); // Close the modal
          })
          .finally(() => {
            // this.loading = false
          });
      }, 15000); // Poll every 10 seconds (adjust as needed)
    },
    closeModal() {
      // Close the Bootstrap modal
      this.$refs.modal.hide();
    },
    async doSubmit() {
      const response = await ApiService.post("settings/status",{
          channel: this.channel,
          provider: this.provider,
          id: this.transaction_id

      });
      const status = response.data.status;

      console.log(status);
      if (status === "success") {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null; // Reset intervalId to null after clearing
        }

       this.closeModal()
        this.$refs.paymentSuccessModal.openModal();
      } else if (status === "failure") {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null; // Reset intervalId to null after clearing
        }
       this.closeModal() // Close the modal

       this.$refs.paymentFailureModal.openModal('Your payment was not successful. Please try again later.');

      } else {
        // Payment is still pending, update progress message
      }
    },
  },
};
</script>